export enum PaginationActions {
  prev = 'prev',
  next = 'next',
}
